import React from "react";
import {convertPath} from "@common/utils/path/linkPath";

function BtnText({ link, text, leftIcon, rightIcon, color, onClick}) {

  return (
      link ?
        <a href={`${convertPath(`${link}`)}`} className={`btn-text ${color}`}>
          {leftIcon && <i className={`left-icon mdi mdi-${leftIcon}`}/>}
          {text}
          {rightIcon && <i className={`right-icon mdi mdi-${rightIcon}`}/>}
        </a>
        :
        <button className={`btn-text ${color}`} onClick={onClick}>
          {leftIcon && <i className={`left-icon mdi mdi-${leftIcon}`}/>}
          {text}
          {rightIcon && <i className={`right-icon mdi mdi-${rightIcon}`}/>}
        </button>
  );
}

export default BtnText;
